import { NgModule } from "@angular/core";
import { TrendingUpIconComponent } from "./arrow-trending-up/arrow-trending-up-icon.component";
import { ChevronDownComponent } from "./chevron-down/chevron-down.component";
import { GraphIconComponent } from "./graph/graph-icon.component";
import { DownloadIconComponent } from "./download/download-icon.component";
import { DocumentArrowUpIconComponent } from "./document-arrow-up/document-arrow-up-icon.component";
import { PencilSquareComponent } from "./pencil-square/pencil-square.component";
import { XMarkComponent } from "./x-mark/x-mark.component";


@NgModule({
    imports: [
        TrendingUpIconComponent,
        ChevronDownComponent,
        GraphIconComponent,
        DownloadIconComponent,
        DocumentArrowUpIconComponent,
        XMarkComponent,
        PencilSquareComponent,
    ],
    declarations: [

    ],
    exports: [
        TrendingUpIconComponent,
        ChevronDownComponent,
        GraphIconComponent,
        DownloadIconComponent,
        DocumentArrowUpIconComponent,
        XMarkComponent,
        PencilSquareComponent,
    ],
})
export class IconsModule {}

